import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Search from './Search';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  search: {
    flexGrow: 1,
    maxWidth: '100%',
    flexBasis: 480,
  },
  filterButton: {
    marginLeft: 'auto',
  },
  filterIcon: {
    marginRight: theme.spacing(1),
  },
}));

function SearchBar({
  onSearch,
  onChange,
  className,
  resetInput,
  disabled,
  btnDisabled,
  searchInputStyle,
  inputType,
  ...rest
}) {
  const classes = useStyles();
  // eslint-disable-next-line no-unused-vars
  const [openFilter, setOpenFilter] = useState(false);

  return (
    <Grid {...rest} className={clsx(classes.root, className)} container spacing={3}>
      <Grid item className={classes.search}>
        <Search
          onSearch={onSearch}
          onChange={onChange}
          resetInput={resetInput}
          disabled={disabled}
          btnDisabled={btnDisabled}
          searchInputStyle={searchInputStyle}
          inputType={inputType}
          {...rest}
        />
      </Grid>
    </Grid>
  );
}

SearchBar.propTypes = {
  className: PropTypes.string,
  onFilter: PropTypes.func,
  onSearch: PropTypes.func,
  resetInput: PropTypes.string,
};

export default SearchBar;
